<template>
    <div class="">
        <div class="d-flex align-items-center p-4">
            <div class="title title-primary d-flex w-50 m-0">
            <DynamicIcon icon="multiple-letter" classString="container-title-icon mr-2"/>
            <p class="d-flex align-items-center mt-1 optum-bold font-24px">Lista de Usuários</p> 
            </div>
            <div class="w-50 d-flex justify-content-end">
            <b-button pill class="btn-base primary-btn" @click="showModalForm = true">Adicionar usuário</b-button>
            <ModalFormUsuario @close="showModalForm = null" @updated="filter" v-if="showModalForm"/>
            </div>
        </div>

        <ToogleFilterBox classString="mx-4" title="Filtrar" :isFilter="true" @filter="filter" @resetFilter="resetFilter">
            <div class="row col-md-12 m-0 p-0"> 
                <b-form-group label="CPF" label-for="cpf" class="col-md-3 col-12 px-1">
                    <b-form-input id="cpf" placeholder="Digite aqui" 
                    v-model="form.cpf" v-mask="['###.###.###-##']" trim></b-form-input>
                </b-form-group>

                <b-form-group label="Nome" label-for="name" class="col-md-3 col-12 px-1">
                    <b-form-input id="name" placeholder="Digite aqui" v-model="form.name" trim></b-form-input>
                </b-form-group>

                <b-form-group label="E-mail" label-for="email" class="col-md-3 col-12 px-1">
                    <b-form-input id="email" placeholder="Digite aqui" v-model="form.email" trim></b-form-input>
                </b-form-group>

                <b-form-group label="Perfil" label-for="perfil" class="col-md-3 col-12 px-1">
                    <b-form-select id="perfil" v-model="form.profile" :options="selectOptionsPerfil"></b-form-select>
                </b-form-group>

                <b-form-group label="Status" label-for="disabled" class="col-md-3 col-12 px-1">
                    <b-form-select id="disabled" v-model="form.disabled" :options="selectOptions"></b-form-select>
                </b-form-group>

                <b-form-group label="Empresa" label-for="empresa" class="col-md-3 col-12 px-1">
                    <InputAutocomplete :loader="empresaAutocompleteLoader" v-model="form.empresa" />
                </b-form-group>

                <b-form-group id="input-group-2" label="Data de cadastro (inicial)" label-for="data-inicial" class="col-md-3 col-12 px-1">
                    <InputDate2 label="" v-model="form.dataInicial"/>
                    <b-form-invalid-feedback :state="stateInicialDate" style="width: 100%">{{validateMessage.inicialDate}}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="input-group-2" label="Data de cadastro (final)" label-for="data-final" class="col-md-3 col-12 px-1">
                    <InputDate2 label="" v-model="form.dataFinal"/>
                    <b-form-invalid-feedback b-form-invalid-feedback :state="stateFinalDate" style="width: 100%">{{validateMessage.finalDate}}</b-form-invalid-feedback>
                </b-form-group>
            </div>
        </ToogleFilterBox>
    </div>
</template>

<script>
import { mask, tokens } from 'vue-the-mask'
import Validations from '@/util/Validations'
import InputAutocomplete from "@/components/commons/Inputs/InputAutocomplete"
import PerfilResource from "@/resources/PerfilResource"
import EmpresaResource from "@/resources/EmpresaResource"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import ToogleFilterBox from "@/components/commons/ToogleFilterBox.vue";
import ModalFormUsuario from './ModalFormUsuario.vue'
import InputDate2 from "@/components/commons/Inputs/InputDate2"

export default {
    name: "ListarUsuarioFiltro",
    directives: {mask, tokens},
    components: {
        InputAutocomplete,
        DynamicIcon,
        ToogleFilterBox,
        ModalFormUsuario,
        InputDate2
    },
    data(){
        return {
            form : {
                cpf : null,
                name : null,
                email: null,
                disabled: null,
                dataInicial : null,
                dataFinal : null,
                profile: null,
                empresa: null
            },
            selectOptions : [
                { value: null, text: '(Selecione)'},
                { value: false, text: 'Ativo' },
                { value: true, text: 'Desabilitado' },
            ],
            selectOptionsPerfil : [{ value: null, text: '(Selecione)'}],
            validateMessage : {
                inicialDate : null,
                finalDate : null                
            },
            showModalForm: null
        }
    },
    computed : {
        stateInicialDate(){
            return this.validateMessage.inicialDate ? false : null
        },
        stateFinalDate(){
            return this.validateMessage.finalDate ? false : null
        }
    },
    methods: {
        empresaAutocompleteLoader: EmpresaResource.autocomplete,
        filter() {
            this.validateMessage.inicialDate = null
            this.validateMessage.finalDate = null

            if( Validations.isEmpty(this.form) ){
                this.$emit("filter", {} )    
            } else {
                let form = {
                    ...this.form,
                    cpf: this.form.cpf && this.form.cpf.replaceAll("-","").replaceAll(".","") || null,
                    name: this.form.name && this.form.name.toUpperCase() || null,
                    empresaId: this.form.empresa && this.form.empresa.id
                }

                this.$emit("filter", form)
            }           
		},
        resetFilter(){
            this.validateMessage.inicialDate = null
            this.validateMessage.finalDate = null
            
            for (let key in this.form)
            {
                this.form[key] = null
            }
        },
        verificaData( str ) {
            if(!this.form.dataInicial || !this.form.dataFinal) {
                return 
            }

            this.validateMessage.inicialDate = null
            this.validateMessage.finalDate = null

            let InicialData = new Date(this.form.dataInicial)
            let FinalData = new Date(this.form.dataFinal)
            let AtualData = new Date()
            
            if(str == "inicial"){
                if(InicialData >= FinalData){
                    this.form.dataInicial = null,
                    this.validateMessage.inicialDate = "Data incial não pode ser maior que a data final."
                    return 
                }
            }
            
            if(str == "final"){
                if(FinalData <= InicialData){
                    this.form.dataFinal = null
                    this.validateMessage.finalDate = "Data final não pode ser menor que a data inicial."
                    return
                } else if(FinalData >= AtualData){
                    this.form.dataFinal = null
                    this.validateMessage.finalDate = "Data final não pode ser maior que a data atual."
                    return
                }
            }
        }
    },
    created() {
        PerfilResource.list(true, {context: "perfil", showLoader: true})
			.then((perfis) => {
                perfis.forEach( item => {
                    this.selectOptionsPerfil.push( { value: item.id, text: item.name})
                })
				
			})
    }
}

</script>

<style scoped>

#checkboxFilterCases{
    display: none;
}

input, select{
    font-size: 14px !important;
}

#checkboxFilterCases:checked ~ .form-filter-cases{
    height: 0px;
    padding: 0px;
    overflow: hidden;
}

.icon-chevron-up{
    margin-left: 10px;
    transition: 0.2s;
    font-size: 14px !important;
}

#checkboxFilterCases:checked ~ label{
    border-radius: 10px;
    transition-delay: 0.2s;
}

#checkboxFilterCases:checked ~ label .icon-chevron-up{
    transform: rotate(180deg);
}

.label-filter-cases{
    width: 100%;
    height: 45px;
    color: #EFEFEE !important;    
    background-color: #bbbec0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px !important;
    letter-spacing: 2px !important;
    border-radius: 10px 10px 0px 0px;
    transition: 0.2s;
}

.label-filter-cases:hover{
    cursor: pointer;
    background-color: #9d9fa0;
}

.form-filter-cases{
    width: 100%;
    display: flex;
    padding: 15px 0px;
    flex-wrap: wrap;
    justify-content: flex-end;
    transition: 0.2s;
    background-color: #fff;
    border-radius: 0px 0px 10px 10px;
}

.form-filter-cases input, .form-filter-cases select{
    border: 1px solid #bbbec0 !important;  
}

.input-100-filter-cases{
    width: calc(100% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-20-filter-cases{
    width: calc(20% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-40-filter-cases{
    width: calc(40% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-25-filter-cases{
    width: calc(25% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-35-filter-cases{
    width: calc(35% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-15-filter-cases{
    width: calc(15% - 20px);
    margin: 0px 10px 10px 10px;
}

@media (max-width: 620px){
    .input-20-filter-cases, .input-40-filter-cases, .input-15-filter-cases, .input-35-filter-cases, .input-25-filter-cases{
        width: calc(100% - 20px);
    }
}

@media (max-width: 930px){
    .label-filter-cases{
        border-radius: 0px;
    }

    #checkboxFilterCases:checked ~ label{
        border-radius: 0px;
    }

    .listing-cases{
        border-radius: 0px;
    }
}


</style>